export default "__VITE_ASSET__qqCoHaXF__"